import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  RISA = 'RISA',
}

export const queryKeys = {
  RISA: (clientId: string) => [QueryFeature.RISA, QueryKey.RISA, clientId],
};
